import React from 'react';

const FullyCenteredDiv: React.FC = ({ children }): React.ReactElement => {
	return <div className="flex h-full items-center justify-center">{children}</div>;
};

export default FullyCenteredDiv;
